import * as React from 'react';
import styled from '@emotion/styled';
import { useTranslation, Trans } from 'react-i18next';
import { Link, tokens } from '@hotjar/hotsauce';

const INVITE_SCREEN_PATH = '/team/invite/';

const Wrapper = styled.div`
  padding: ${tokens.spacer.x1} ${tokens.spacer.x1};
  ${tokens.text('caption')}
`;

interface SuggestionFooterProps {
  organizationName: string;
  hasOrgInvitePermission: boolean;
}

function InviteScreenLink({
  organizationName,
  children,
}: {
  organizationName: string;
  children?: React.ReactNode;
}) {
  return (
    <Link
      href={INVITE_SCREEN_PATH}
      kind="inline"
      onClick={(e: React.SyntheticEvent) => {
        // NOTE: router in Angular app intercepts URL change even if
        // target is _blank
        window.open((e.target as HTMLAnchorElement).href);
      }}
    >
      {`${children} ${organizationName}`}
    </Link>
  );
}

export const SuggestionsFooter = ({
  organizationName,
  hasOrgInvitePermission,
}: SuggestionFooterProps): JSX.Element => {
  const { t } = useTranslation();

  const userSpecific = hasOrgInvitePermission ? (
    <Trans i18nKey="comment:create.cannot-find-teammate.admin">
      <InviteScreenLink organizationName={organizationName} />
    </Trans>
  ) : (
    <Trans i18nKey="comment:create.cannot-find-teammate.user">{organizationName}</Trans>
  );

  return (
    <Wrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {t('comment:create.cannot-find-teammate.common')} {userSpecific}
    </Wrapper>
  );
};
